import { Typography } from '@mui/material';
import {
  DataGrid,
  GridColDef,
  GridInputRowSelectionModel,
  deDE,
} from '@mui/x-data-grid';
import React, { useCallback, useMemo } from 'react';
import { ILegalTransactionRelationshipRealEstate } from '../../../Interfaces/ILegalTransactionRelationship/ILegalTransactionRelationshipRealEstate/ILegalTransactionRelationshipRealEstate';
import { IPropertyType } from '../../../Interfaces/IPropertyType';

const columnsPropertyType: GridColDef[] = [
  {
    field: 'PropertyType',
    headerName: 'Beschreibung',
    description: 'Mögliche Grundstücksarten',
    sortable: false,
    flex: 1,
  },
];
interface IProps {
  formValues: ILegalTransactionRelationshipRealEstate;
  setFormValues: React.Dispatch<
    React.SetStateAction<ILegalTransactionRelationshipRealEstate>
  >;
  propertyTypes: IPropertyType[];
}

const PAGE_SIZE = 10;

export const RealEstatePropertyTypes: React.FC<IProps> = ({
  formValues: { PropertyTypeArray },
  setFormValues,
  propertyTypes,
}) => {
  const takenPropertyTypes = useMemo(
    () => PropertyTypeArray.map(x => x.idPropertyType),
    [PropertyTypeArray]
  );

  const onChange = useCallback(
    (selectedPropertyModel: GridInputRowSelectionModel) => {
      if (!Array.isArray(selectedPropertyModel)) return;
      setFormValues(prev => ({
        ...prev,
        PropertyTypeArray: selectedPropertyModel.map(x => ({
          idPropertyType: Number(x),
          idRealEstate: prev.idRealEstate,
        })),
      }));
    },
    [setFormValues]
  );

  return (
    <>
      <Typography variant='h5' sx={{ mt: 2, mb: 1 }}>
        Grundstücksform
        <br />
        <Typography>
          Bitte erfassen Sie alle Formen, welche sich auf dem Grundstück
          befinden.
        </Typography>
      </Typography>
      <DataGrid
        sx={{ mt: 2 }}
        autoHeight
        localeText={deDE.components.MuiDataGrid.defaultProps.localeText}
        rows={propertyTypes}
        columns={columnsPropertyType}
        getRowId={row => row.idPropertyType}
        pageSizeOptions={[PAGE_SIZE]}
        checkboxSelection
        rowSelectionModel={takenPropertyTypes}
        onRowSelectionModelChange={onChange}
        pagination={propertyTypes.length > PAGE_SIZE || undefined}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: PAGE_SIZE,
            },
          },
        }}
      />
    </>
  );
};
